export const Types = {
  GET_SUBSCRIPTION_REQUEST: 'subscription/GET_REQUEST',
  GET_SUBSCRIPTION_SUCCESS: 'subscription/GET_SUCCESS',
  GET_SUBSCRIPTION_MOBILE_REQUEST: 'subscription_mobile/GET_REQUEST',
  GET_SUBSCRIPTION_MOBILE_SUCCESS: 'subscription_mobile/GET_SUCCESS',
  CANCEL_SUBSCRIPTION_REQUEST: 'subscription/CANCEL_SUBSCRIPTION_REQUEST',
  GET_PAYMENTS_REQUEST: 'payments/GET_REQUEST',
  GET_PAYMENTS_SUCCESS: 'payments/GET_SUCCESS',
  POST_VOUCHERS_APPLY_REQUEST: 'vouchers/POST_REQUEST',
  GET_VOUCHERS_REQUEST: 'vouchers/GET_REQUEST',
  GET_VOUCHERS_SUCCESS: 'vouchers/GET_SUCCESS',
};

const INITIAL_STATE = {
  subscription: { loading: false, data: {} },
  subscriptionMobile: { loading: false, data: {} },
  payments: { loading: false, data: [] },
  vouchers: { loading: false, data: [] },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.GET_SUBSCRIPTION_REQUEST:
      return { ...state, subscription: { ...state.subscription, loading: true } };
    case Types.GET_SUBSCRIPTION_SUCCESS:
      if (action.payload.data === null) {
        return state;
      }
      return {
        ...state,
        subscription: {
          ...state.subscription,
          data: action.payload.data,
          loading: false,
        },
      };
    case Types.GET_SUBSCRIPTION_MOBILE_REQUEST:
      return { ...state, subscriptionMobile: { ...state.subscriptionMobile, loading: true } };
    case Types.GET_SUBSCRIPTION_MOBILE_SUCCESS:
      if (action.payload.data === null) {
        return state;
      }
      return {
        ...state,
        subscriptionMobile: {
          ...state.subscriptionMobile,
          data: action.payload.data,
          loading: false,
        },
      };
    case Types.GET_PAYMENTS_REQUEST:
      return { ...state, payments: { ...state.payments, loading: true } };
    case Types.GET_PAYMENTS_SUCCESS:
      if (action.payload.data === null) {
        return state;
      }
      return {
        ...state,
        payments: {
          ...state.payments,
          data: action.payload.data.subscription_payments,
          loading: false,
        },
      };
    case Types.GET_VOUCHERS_REQUEST:
      return { ...state, vouchers: { ...state.vouchers, loading: true } };
    case Types.GET_VOUCHERS_SUCCESS:
      if (action.payload.data === null) {
        return state;
      }
      return {
        ...state,
        vouchers: {
          ...state.vouchers,
          data: action.payload.data,
          loading: false,
        },
      };
    default:
      return state;
  }
};

export const Creators = {
  getSubscriptionRequest: () => ({ type: Types.GET_SUBSCRIPTION_REQUEST }),
  getSubscriptionSuccess: data => ({
    type: Types.GET_SUBSCRIPTION_SUCCESS,
    payload: { data },
  }),
  getSubscriptionMobileRequest: () => ({ type: Types.GET_SUBSCRIPTION_MOBILE_REQUEST }),
  getSubscriptionMobileSuccess: data => ({
    type: Types.GET_SUBSCRIPTION_MOBILE_SUCCESS,
    payload: { data },
  }),
  getPaymentsRequest: () => ({ type: Types.GET_PAYMENTS_REQUEST }),
  getPaymentsSuccess: data => ({
    type: Types.GET_PAYMENTS_SUCCESS,
    payload: { data },
  }),
  cancelSubscription: () => ({ type: Types.CANCEL_SUBSCRIPTION_REQUEST }),
  applyVoucher: code => ({ type: Types.POST_VOUCHERS_APPLY_REQUEST, code }),
  getVouchersRequest: () => ({ type: Types.GET_VOUCHERS_REQUEST }),
  getVouchersSuccess: data => ({
    type: Types.GET_VOUCHERS_SUCCESS,
    payload: { data },
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/subscription.js